import kazakhstan from '../../Stories/stories-images/kazakhstan.jpg';
import malawi from '../../Stories/stories-images/malawi.jpg';
// import pakistan from '../../Stories/stories-images/pakistan.jpg';
import pakistan3 from '../../Stories/stories-images/pakistan3.jpg';
import mexico from '../../Stories/stories-images/mexico.jpg';
import nepalChw from '../../Stories/stories-images/nepal_chw.jpg';
import moldova from '../../Stories/stories-images/moldova1.jpeg';
import ethiopia from '../../Stories/stories-images/ethiopia.jpg';
import indonesia from '../../Stories/stories-images/indonesia1.jpg';
import nigeria from '../../Stories/stories-images/nigeria.png';

export interface IVideo {
    country: string;
    image: any;
    imagealt: string;
    person: string;
    title: string;
    watchTime: string;
    link: string;
    youtubeId: string;
}

export const videos: IVideo[] = [
    {
        country: 'Nigeria',
        image: nigeria,
        imagealt: "Engaging religious leaders as change agents to strengthen sexual and reproductive health and rights",
        person: 'Dr. Aaliya Bibi',
        title: 'Engaging religious leaders as change agents to strengthen sexual and reproductive health and rights',
        watchTime: '16 min watch',
        link: 'https://youtu.be/pW7XDi6H3eQ',
        youtubeId: 'pW7XDi6H3eQ',
    },
    {
        country: 'Moldova',
        image: moldova,
        imagealt: "A systems approach to advancing adolescent sexual and reproductive health and rights in Moldova.",
        person: 'Dr. Galina Lesco',
        title: 'A systems approach to advancing adolescent sexual and reproductive health and rights in Moldova.',
        watchTime: '9 min watch',
        link: 'https://youtu.be/YrBMcH2_2W0',
        youtubeId: 'YrBMcH2_2W0',
    },
    {
        country: 'Pakistan',
        image: pakistan3,
        imagealt: "Rural Ambulance Service: A public-private transport solution for pregnant women.",
        person: 'Dr. Naeem Majeed',
        title: 'Rural Ambulance Service: A public-private transport solution for pregnant women.',
        watchTime: '14 min watch',
        link: 'https://youtu.be/Pdkf54k3cwA',
        youtubeId: 'Pdkf54k3cwA',
    },
    {
        country: 'Kazakhstan',
        image: kazakhstan,
        imagealt: "This picture reflects the context of the story, strengthening policies and legislation for better adolescent health in Kazakhstan",
        person: 'Dr Serik Tanirbergenov',
        title: 'Advancing adolescent health through policy and legislation',
        watchTime: '6 min watch',
        link: 'https://youtu.be/htKx3iGj85Y',
        youtubeId: 'htKx3iGj85Y',
    },
    {
        country: 'Nepal',
        image: nepalChw,
        imagealt: "This picture reflects the context of the story, women waiting for health services in Nepal",
        person: 'Dr Sabitri Sapkota and Ms Durpata Saud',
        title: 'Community health workers expand access to sexual and reproductive health services in rural areas',
        watchTime: '8 min watch',
        link: 'https://www.youtube.com/watch?v=yV2CJFXTlgw',
        youtubeId: 'yV2CJFXTlgw',
    },
    {
        country: 'Mexico',
        image: mexico,
        imagealt: "This picture reflects the context of the story, a waiting room for health services for indigenous communities in Mexico",
        person: 'Professor Gustavo Nigenda',
        title: 'Increasing access to obstetric care for indigenous women through a non-governmental model of care',
        watchTime: '8 min watch',
        link: 'https://youtu.be/QpK1vlXbmto',
        youtubeId: 'QpK1vlXbmto',
    },
    {
        country: 'Malawi',
        image: malawi,
        imagealt: "This picture reflects the context of the story, aligning donor priorities and funds for services such as maternal health in Malawi",
        person: 'Emily Chirwa',
        title: 'Aligning donor and government sexual and reproductive health financing in Malawi',
        watchTime: '4 min watch',
        link: 'https://youtu.be/Suk17pBL-V8',
        youtubeId: 'Suk17pBL-V8',
    },
    {
        country: 'Ethiopia',
        image: ethiopia,
        imagealt: "Menstrual health programming as a foundation for adolescent sexual and reproductive health and rights in Ethiopia",
        person: 'Masresha Soressa',
        title: 'Menstrual health programming as a foundation for adolescent sexual and reproductive health and rights in Ethiopia',
        watchTime: '11 min watch',
        link: 'https://youtu.be/R4pIdQRowEs',
        youtubeId: 'R4pIdQRowEs',
    },
    {
        country: 'Indonesia',
        image: indonesia,
        imagealt: "Decentralizing HIV care and training towards ending HIV in Indonesia",
        person: 'Dr. Yusuf Aulia Rahman and Ms. Otta Nur Kirana',
        title: 'Decentralizing HIV care and training towards ending HIV in Indonesia',
        watchTime: '13 min watch',
        link: 'https://youtu.be/JoE6bcoOmXA',
        youtubeId: 'JoE6bcoOmXA',
    },
]; 